import { Routes, Route, useLocation, useNavigate } from "react-router-dom";
import RestaurentPage from "./pages/restaurent-page/RestaurentPage.jsx";
import CheckOutPage from "./pages/checkout-page/CheckOutPage.jsx";
import OrderPage from "./pages/order-page/OrderPage";
import { RestaurentContextProvider } from "./context/rest_context";
import { useEffect } from "react";
import { CartContextProvider } from "./context/cart_context";
import { UserContextProvider } from "./context/user_context";
import { ref, get } from "firebase/database";
import { db } from "./config/firebase_config.js";
import NotFound from "./pages/notFound/NotFound";
import Confirm_page from "./pages/confirm/Confirm_page";
import "./App.css";
import PaymentStatus from "./pages/payment-status/PaymentStatus";
import Review from "./pages/review/Review.jsx";
import splash from "../src/assets/images/flashpe.png";
import PayuPaymentStatus from "./pages/payu-payments/PayuPayments.jsx";
import RestaurantMapViewPage from "./pages/restaurant-map-view/RestaurantMapViewPage";
import PrebookingRestaurent from "./pages/restaurent-page/PrebookingRestaurent";
import MapAndStores from "./pages/stores/MapAndStores";
import PayBill from "./pages/pay-bill/PayBill";
import TableOrderBookingPage from "./pages/table-order-booking/TableOrderBookingPage";
import Navbar from "./components/Navbar/Navbar";
import MainPage from "./pages/main-page/MainPage.jsx";
import { Toaster } from "react-hot-toast";

// Razorpay

function App() {
  const location = useLocation();
  const pathname = location.pathname;
  const queryParams = new URLSearchParams(location.search);
  const restIDParam = queryParams.get("restID");
  // console.log("<-- restID params ---->", restIDParam, location, "<-------->");
  const restID = restIDParam ? restIDParam.split("<")[0] : null;
  // console.log("<-- restID params ---->", restID, "<-------->");
  // console.log(restID);
  const navigate = useNavigate();

  console.log("pathname--->", pathname);

  useEffect(() => {
    // console.log("useEffect is executing ra ayya ", pathname);
    const checkRest = async () => {
      if (restID != null && pathname === "/") {
        console.log("restID is not null", restID);
        // let needsNavigation = false;
        const databaseRef = ref(db, `${restID}_SubStores`);
        const snapshot = await get(databaseRef);

        if (!snapshot.exists()) {
          const mainRestID = ref(db, `RestaurantMenu/${restID}`);
          const restSnap = await get(mainRestID);
          const restData = restSnap.val();
          if (restData == null) {
            console.log("not exists at all ra ayya ");
            navigate("/404", { replace: true });
            return;
          }
          queryParams.set("storeType", restData.storeType);
          const newUrl = `${location.pathname}?${queryParams.toString()}`;
          window.history.replaceState(null, "", newUrl);
        } else {
          const mainRestID = ref(db, `RestaurantMenu/${restID}`);
          const restSnap = await get(mainRestID);
          const restData = restSnap.val();
          console.log(restData);
          queryParams.set("storeType", restData.storeType);
          console.log(`${location.pathname}?${queryParams.toString()}`);
          const newUrl = `${location.pathname}?${queryParams.toString()}`;
          window.history.replaceState(null, "", newUrl);
          console.log("<-- restSnap params --------->");
        }
        // if (!queryParams.has("storeID")) {
        //   queryParams.set("storeID", restID);
        //   needsNavigation = true;
        // }

        // // 2. Check if we are not already on the /restaurent page
        // if (location.pathname !== "/restaurent") {
        //   needsNavigation = true;
        // }

        // if (needsNavigation) {
        //   // console.log("Navigating to:", `/restaurent?${queryParams.toString()}`);
        //   navigate(`/restaurent?${queryParams.toString()}`, { replace: true });
        // }
      }
    };
    checkRest();
  }, [restID, navigate, location.pathname, location.search]);

  const FooterItem = ({ link, title }) => {
    return (
      <span style={{ fontSize: "12px" }}>
        &#183;{" "}
        <a href={link} target="_blank" rel="noopener noreferrer">
          {title}
        </a>
      </span>
    );
  };

  return (
    <div className=" bg-gradient-to-b from-[#100b17] to-[#0f1029] pt-6">
      <Toaster />
      {location.pathname !== "/paybill" && <Navbar />}
      <div className=" back-container">
        <RestaurentContextProvider>
          <CartContextProvider>
            <Routes>
              <Route
                path="/"
                element={
                  window.location.hostname === "flashpe.net" ||
                  window.location.hostname === "www.flashpe.net" ? (
                    <MapAndStores />
                  ) : (
                    <MainPage restID={restID} />
                  )
                }
              />
              <Route path="/stores" element={<MapAndStores />} />
              <Route path="/restaurent" element={<RestaurentPage />} />
              <Route
                path="/restaurant-map"
                element={<RestaurantMapViewPage />}
              />
              <Route
                path="/prebooking/:restId"
                element={<PrebookingRestaurent />}
              />
              <Route path="/paybill" element={<PayBill />} />
              <Route
                path="/tableOrderBooking/:id"
                element={<TableOrderBookingPage />}
              />
              <Route
                path="/checkout"
                element={
                  <UserContextProvider>
                    <CheckOutPage />
                  </UserContextProvider>
                }
              />
              <Route path="/orderpage" element={<OrderPage />} />
              <Route path="/confirm" element={<Confirm_page />} />
              <Route path="/paymentStatus" element={<PaymentStatus />} />
              <Route path="/payuPayments" element={<PayuPaymentStatus />} />
              <Route path="/review" element={<Review />} />
              <Route path="*" element={<NotFound />} />
            </Routes>
          </CartContextProvider>
        </RestaurentContextProvider>
      </div>
      <footer>
        <img src={splash} width={100} height={100} />
        <span className="flashpe-add">
          Flashpe, Wework Krishe Emerald, Kondapur, Hitech City, Hyderabad,
          India 500081
        </span>
        <div className="footer-tc">
          <FooterItem link="https://www.flashpe.net/" title="About Us" />
          <FooterItem
            link="https://flashpe-terms-condition.web.app/"
            title="Terms of use & Refund Policy"
          />
          <FooterItem
            link="https://diningiosprivacypolicy.web.app/"
            title="Privacy Policy"
          />
          <FooterItem link="https://www.flashpe.net/" title="Contact Us" />
        </div>
      </footer>
    </div>
  );
}

export default App;
